import { HttpResponse } from '@angular/common/http';
import { AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as saveAs from 'file-saver';
import * as JSZip from 'jszip';
import { Subscription, distinctUntilChanged } from 'rxjs';
import { CustomerService } from 'src/app/services/customer.service';
import { DealerPortalService } from 'src/app/services/dealerPortal.service';
import { FileService } from 'src/app/services/file.service';
import { RebateContractService } from 'src/app/services/rebate-contract.service';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.less']
})
export class ContractComponent implements OnInit, AfterViewInit {

  @ViewChild('progressTpl', { static: true }) progressTpl!: TemplateRef<any>;
  @ViewChild('ratioTpl', { static: true }) ratioTpl!: TemplateRef<any>;
  @ViewChild('remainingAmountTpl', { static: true }) remainingAmountTpl!: TemplateRef<any>;

  @Input() tabSelectedIndex: number | undefined;
  private langChangeSub?: Subscription;


  Math = Math;
  chartData: any = [];
  latestUpdateTime: string = "";
  selectedYear = localStorage.getItem("selectedYear") ? localStorage.getItem("selectedYear") : '';
  yearList: string[] = [];

  annualData: any[] = [];
  annualPagination = { pageNum: 1, pageSize: 1000, total: 0 };
  annualColumns: any;

  quarterlyData: any[] = [];
  quarterlyPagination = { pageNum: 1, pageSize: 1000, total: 0 };
  quarterlyColumns: any;

  productData: any[] = [];
  productPagination = { pageNum: 1, pageSize: 1000, total: 0 };
  productColumns: any;

  extraRebateData: any[] = [];
  extraRebatePagination = { pageNum: 1, pageSize: 5, total: 0 };
  extraRebateColumns: any;

  marketRebateData: any[] = [];
  marketPagination = { pageNum: 1, pageSize: 5, total: 0 };
  marketColumns: any;

  firstLoading: boolean = true;

  private customerSubscription: Subscription | undefined;

  private loadingYearList = false;

  constructor(private router: Router, private customerService: CustomerService, private dealerPortalService: DealerPortalService, private translate: TranslateService, private fileService: FileService, private rebateContractService: RebateContractService) { }

  ngAfterViewInit() {
    setTimeout(() => {
      this.annualColumns = [
        { title: 'CONTRACT_CODE', key: 'ssqContractNo', width: '150px',align:'center' },
        { title: 'CURRENT_CONTRACT_AMOUNT', key: 'purchaseTarget', width: '120px' },
        { title: 'CURRENT_CONTRACT_PRICE', key: 'purchaseAmount', width: '120px' },
        { title: 'COMPLETION_RATE', key: 'completionRate', width: '180px', template: this.progressTpl,align:'center' },
        { title: 'WAITING_COMPLETION_AMOUNT', key: 'pendingAmount', width: '150px', template: this.remainingAmountTpl },
        { title: 'TARGET_REBATE_AMOUNT', key: 'targetRebateAmount', width: '130px' },
        { title: 'REWARD_RATIO', key: 'rewardRatio', width: '100px', template: this.ratioTpl },
        { title: 'ESTIMATED_REBATE_AMOUNT', key: 'estimatedRebateAmount', width: '130px' },
        { title: 'SETTLED_REBATE_AMOUNT', key: 'settledRebateAmount', width: '150px' },
        { title: 'ISSUED_REBATE_AMOUNT', key: 'issuedRebateAmount', width: '150px' },
        { title: 'MAIN_CONTRACT_AMOUNT', key: 'masterContractNo', width: '120px' },
        { title: 'CONTRACT_STATUS', key: 'contractStatus', width: '100px' },
      ];
      this.quarterlyColumns = [
        { title: 'YEAR_A', key: 'year', width: '60px',align:'center' },
        { title: 'QUARTER', key: 'quarter', width: '110px',align:'center' },
        { title: 'CURRENT_CONTRACT_AMOUNT', key: 'purchaseTarget', width: '130px' },
        { title: 'CURRENT_CONTRACT_PRICE', key: 'purchaseAmount', width: '130px' },
        { title: 'COMPLETION_RATE', key: 'completionRate', width: '180px', template: this.progressTpl,align:'center' },
        { title: 'WAITING_COMPLETION_AMOUNT', key: 'pendingAmount', width: '150px', template: this.remainingAmountTpl },
        { title: 'TARGET_REBATE_AMOUNT', key: 'targetRebateAmount', width: '130px' },
        { title: 'REWARD_RATIO', key: 'rewardRatio', width: '130px', template: this.ratioTpl },
        { title: 'ESTIMATED_REBATE_AMOUNT', key: 'estimatedRebateAmount', width: '150px' },
        { title: 'SETTLED_REBATE_AMOUNT', key: 'settledRebateAmount', width: '160px' },
        { title: 'ISSUED_REBATE_AMOUNT', key: 'issuedRebateAmount', width: '160px' },
        { title: 'CONTRACT_STATUS', key: 'contractStatus', width: '100px' },
      ];
      this.extraRebateColumns = [
        { title: 'APPLICATION_CONTRACT_NUMBER', key: 'additionalContractCode', width: '180px', fixed: 'left' as const,align:'center' },
        { title: 'CONTRACT_CODE', key: 'ssqContractCode', width: '180px', fixed: 'left' as const,align:'center' },
        { title: 'CONTRACT_NAME', key: 'contractName', width: '180px', fixed: 'left' as const,align:'center' },
        { title: 'PRODUCT_LINE', key: 'productLine', width: '130px', fixed: 'left' as const,align:'center' },
        { title: 'CONTRACT_START_DATE', key: 'contractStartDate', width: '150px',align:'center' },
        { title: 'CONTRACT_END_DATE', key: 'contractEndDate', width: '150px',align:'center' },
        { title: 'CONTRACT_TYPE', key: 'contractType', width: '150px',align:'center' },
        { title: 'REBATE_METHOD', key: 'rebateMethod', width: '150px',align:'center' },
        { title: 'ACHIEVEMENT_RATE_AMOUNT', key: 'amountCompletionRate', width: '150px', template: this.progressTpl,align:'center' },
        { title: 'ACHIEVEMENT_RATE_QUANTITY', key: 'quantityCompletionRate', width: '200px', template: this.ratioTpl },
        { title: 'REWARD_RATIO', key: 'rewardRate', width: '200px' , template: this.ratioTpl},
        { title: 'TARGET_AMOUNT', key: 'targetAmount', width: '150px' },
        { title: 'TARGET_QUANTITY', key: 'targetQuantity', width: '150px' },
        { title: 'REBATE_CAP_AMOUNT', key: 'rebateCapAmount', width: '200px' },
        { title: 'REWARD_PER_UNIT', key: 'rewardPerUnit', width: '200px' },
        { title: 'ACTUAL_PURCHASE_AMOUNT', key: 'actualPurchaseAmount', width: '150px' },
        { title: 'ESTIMATED_REBATE_AMOUNT', key: 'estimatedRebateAmount', width: '150px' },
        { title: 'ACTUAL_REBATE_AMOUNT', key: 'actualRebateAchieved', width: '150px' },
        { title: 'SETTLED_REBATE_AMOUNT', key: 'settledRebateAmount', width: '150px' },
        { title: 'ISSUED_REBATE_AMOUNT', key: 'paidRebateAmount', width: '150px' },
        { title: 'CONTRACT_STATUS', key: 'contractStatus', width: '100px' },
      ];
      this.marketColumns = [
        { title: 'APPLICATION_CONTRACT_NUMBER', key: 'marketContractCode', width: '180px', fixed: 'left' as const,align:'center' },
        { title: 'CONTRACT_NAME', key: 'contractName', width: '200px',align:'center'},
        { title: 'PRODUCT_LINE', key: 'productLine', width: '130px',align:'center' },
        { title: 'CONTRACT_START_DATE', key: 'contractStartDate', width: '150px',align:'center' },
        { title: 'CONTRACT_END_DATE', key: 'contractEndDate', width: '200px',align:'center' },
        { title: 'CURRENT_CONTRACT_AMOUNT', key: 'purchaseTarget', width: '150px' },
        { title: 'REBATE_CAP_AMOUNT', key: 'rebateCapAmount', width: '200px' },
        { title: 'COMPLETION_RATE', key: 'completionRate', width: '180px', template: this.progressTpl,align:'center' },
        { title: 'ESTIMATED_REBATE_AMOUNT', key: 'estimatedRebateAmount', width: '150px' },
        { title: 'ACTUAL_REBATE_AMOUNT', key: 'actualAchievedRebate', width: '150px' },
        { title: 'SETTLED_REBATE_AMOUNT', key: 'settledRebateAmount', width: '150px' },
        { title: 'ISSUED_REBATE_AMOUNT', key: 'paidRebateAmount', width: '150px' },
        { title: 'CONTRACT_STATUS', key: 'contractStatus', width: '100px' },
      ];
      this.productColumns = [
        { title: 'YEAR_A', key: 'year', width: '60px',align:'center' },
        { title: 'PRODUCT_LINE', key: 'productLineNameCn', width: '110px',align:'center' },
        { title: 'CURRENT_CONTRACT_AMOUNT', key: 'purchaseTarget', width: '130px' },
        { title: 'CURRENT_CONTRACT_PRICE', key: 'purchaseAmount', width: '130px' },
        { title: 'COMPLETION_RATE', key: 'completionRate', width: '180px', template: this.progressTpl,align:'center' },
        { title: 'WAITING_COMPLETION_AMOUNT', key: 'pendingAmount', width: '150px', template: this.remainingAmountTpl },
        { title: 'TARGET_REBATE_AMOUNT', key: 'targetRebateAmount', width: '130px' },
        { title: 'REWARD_RATIO', key: 'rewardRatio', width: '130px', template: this.ratioTpl },
        { title: 'ESTIMATED_REBATE_AMOUNT', key: 'estimatedRebateAmount', width: '150px' },
        { title: 'SETTLED_REBATE_AMOUNT', key: 'settledRebateAmount', width: '160px' },
        { title: 'ISSUED_REBATE_AMOUNT', key: 'issuedRebateAmount', width: '160px' },
        { title: 'CONTRACT_STATUS', key: 'contractStatus', width: '100px' },
      ];
    });
  }

  async ngOnInit(): Promise<void> {
    this.firstLoading = true;
    await this.getYearList();
    this.firstLoading = false;
    this.customerSubscription = this.customerService.selectedCustomer$.pipe(distinctUntilChanged()).subscribe(() => {
      if (!this.firstLoading && this.router.url.includes('/contracts_rebates') && this.tabSelectedIndex == 0) {
        this.annualPagination = { pageNum: 1, pageSize: 1000, total: 0 };
        this.quarterlyPagination = { pageNum: 1, pageSize: 1000, total: 0 };
        this.productPagination = { pageNum: 1, pageSize: 1000, total: 0 };
        this.extraRebatePagination = { pageNum: 1, pageSize: 5, total: 0 };
        this.marketPagination = { pageNum: 1, pageSize: 5, total: 0 };
        // this.selectedYear = "";
        this.getYearList()
      }
    });
    this.setChartData();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.setChartData();
    });
  }
  

  onYearChange(year: string) {
    this.selectedYear = year;
    localStorage.setItem("selectedYear", year);
    this.annualPagination = { pageNum: 1, pageSize: 1000, total: 0 };
    this.quarterlyPagination = { pageNum: 1, pageSize: 1000, total: 0 };
    this.productPagination = { pageNum: 1, pageSize: 1000, total: 0 };
    this.extraRebatePagination = { pageNum: 1, pageSize: 5, total: 0 };
    this.marketPagination = { pageNum: 1, pageSize: 5, total: 0 };
    this.getYearList(true);
  }
  
  formatMoney(value: any, decimals = 2): string {
    if (value === null || value === undefined || value === '' || value === 0) {
      return '-';
    }

    const num = Number(value);
    if (isNaN(num)) {
      return String(value);
    }

    return num
      .toFixed(decimals)                   
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  private setChartData() {
    this.chartData = [
      { label: this.translate.instant('TARGET_REBATE_AMOUNT'), value: 0, color: '#9E2896',tips: "目标返利金额（含税）：按照合同约定完成目标后可得含税返利金额" },
      { label: this.translate.instant('SETTLED_REBATE_AMOUNT'), value: 0, color: '#F19F23',tips: "以合同年份累计的已结算返利金额（含税）：按合同约定和实际采购额结算待客户确认的返利金额" },
      { label: this.translate.instant('ISSUED_REBATE_AMOUNT'), value: 0, color: '#18837E' ,tips: "以合同年份累计的已发放返利金额（含税）：客户已确认并已发放的返利金额"},
    ];
  }

  initData() {
    this.loadAnnuals();
    this.loadQuarterlys();
    this.loadProducts();
    this.loadMarketData();
    this.loadExtraData();
  }

  getColorByValue(progress: number): string {
    return (progress*100) >= 90 ? '#9E2896' : '#007BC0';
  }
formatPercent = (percent: number| string): string => {
  const num = Number(percent);
  return `${num.toFixed(1)}%`;
  };

  getYearList(isChange:boolean  = false) {
    if (this.loadingYearList) return;
    this.loadingYearList = true;
    this.rebateContractService.getYearList({ year: this.selectedYear }).subscribe(async result => {
      const { rtnData } = result;
      this.yearList = rtnData.allYear;
      if (!this.yearList?.length) {
        // this.selectedYear = '';
        this.annualData = [];
        this.quarterlyData = [];
        this.productData = [];
        this.extraRebateData = [];
        this.marketRebateData = [];
        return;
      }
      const { targetRebateAmount, settledRebateAmount, paidRebateAmount } = rtnData.rebateAmountTotalDto;
      this.chartData[0].value = targetRebateAmount;
      this.chartData[1].value = settledRebateAmount;
      this.chartData[2].value = paidRebateAmount;
      if(!isChange && this.selectedYear === ''){
        this.selectedYear = this.yearList[0];
        localStorage.setItem("selectedYear", this.yearList[0]);
      }
      await this.initData();
      this.loadingYearList = false;
      this.latestUpdateTime = rtnData.latestUpdateTime;
    }, () => {
      this.loadingYearList = false;
    });
  }

  loadAnnuals(event?: { pageIndex: number, pageSize: number }) {
    if (event) {
      this.annualPagination.pageNum = event.pageIndex;
      this.annualPagination.pageSize = event.pageSize;
    }

    this.rebateContractService.getAnnualList({ pageNum: this.annualPagination.pageNum, pageSize: this.annualPagination.pageSize, year: this.selectedYear })
      .subscribe(res => {
        const { records, total } = res.rtnData;
        this.annualData = records;
        this.annualPagination.total = total;
      });
  }
  loadQuarterlys(event?: { pageIndex: number, pageSize: number }) {
    if (event) {
      this.quarterlyPagination.pageNum = event.pageIndex;
      this.quarterlyPagination.pageSize = event.pageSize;
    }

    this.rebateContractService.getQuarterlyList({ pageNum: this.quarterlyPagination.pageNum, pageSize: this.quarterlyPagination.pageSize, year: this.selectedYear })
      .subscribe(res => {
        const { records, total } = res.rtnData;
        this.quarterlyData = records;
        this.quarterlyPagination.total = total;
      });
  }

  loadProducts(event?: { pageIndex: number, pageSize: number }) {
    if (event) {
      this.productPagination.pageNum = event.pageIndex;
      this.productPagination.pageSize = event.pageSize;
    }
    this.rebateContractService.getProductlineList({ pageNum: this.productPagination.pageNum, pageSize: this.productPagination.pageSize, year: this.selectedYear })
      .subscribe(res => {
        const { records, total } = res.rtnData;
        this.productData = records;
        this.productPagination.total = total;
      });
  }

  loadExtraData(event?: { pageIndex: number, pageSize: number }) {
    if (event) {
      this.extraRebatePagination.pageNum = event.pageIndex;
      this.extraRebatePagination.pageSize = event.pageSize;
    }

    this.rebateContractService.getAdditionallineList({ pageNum: this.extraRebatePagination.pageNum, pageSize: this.extraRebatePagination.pageSize, year: this.selectedYear })
      .subscribe(res => {
        const { records, total } = res.rtnData;
        this.extraRebateData = records;
        this.extraRebatePagination.total = total;
      });
  }

  loadMarketData(event?: { pageIndex: number, pageSize: number }) {
    if (event) {
      this.marketPagination.pageNum = event.pageIndex;
      this.marketPagination.pageSize = event.pageSize;
    }
    this.rebateContractService.getMarketList({ pageNum: this.marketPagination.pageNum, pageSize: this.marketPagination.pageSize, year: this.selectedYear })
      .subscribe(res => {
        const { records, total } = res.rtnData;
        this.marketRebateData = records;
        this.marketPagination.total = total;
      });
  }

  ngOnDestroy(): void {
    this.customerSubscription?.unsubscribe();
    this.langChangeSub?.unsubscribe();
  }

  async exportAnnuals(): Promise<void> {
    await this.fileService
      .exportToExcel(
        `/dealer_portal/target-ach/annual-contract-target-completion/export?year=${this.selectedYear}`
      ).subscribe(async (response: HttpResponse<Blob>) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        let fileName = 'export.xlsx';
        if (contentDisposition) {
          const matches = /filename\*?=(?:UTF-8'')?"?([^"]+)"?/.exec(contentDisposition);
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]);
          }
        }
        saveAs(response.body!, fileName);
      },
        (error: any) => {
          console.error('Error exporting Zip:', error);
        })
  }


  async exportQuarterlys() : Promise<void> {
    await this.fileService
      .exportToExcel(
        `/dealer_portal/target-ach/quarterly-contract-target-completion/export?year=${this.selectedYear}`
      ).subscribe(async (response: HttpResponse<Blob>) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        let fileName = 'export.xlsx';
        if (contentDisposition) {
          const matches = /filename\*?=(?:UTF-8'')?"?([^"]+)"?/.exec(contentDisposition);
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]);
          }
        }
        saveAs(response.body!, fileName);
      },
        (error: any) => {
          console.error('Error exporting Zip:', error);
        })
  }


  async exportProducts() : Promise<void> {
    await this.fileService
      .exportToExcel(
        `/dealer_portal/target-ach/productline-contract-target-completion/export?year=${this.selectedYear}`
      ).subscribe(async (response: HttpResponse<Blob>) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        let fileName = 'export.xlsx';
        if (contentDisposition) {
          const matches = /filename\*?=(?:UTF-8'')?"?([^"]+)"?/.exec(contentDisposition);
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]);
          }
        }
        saveAs(response.body!, fileName);
      },
        (error: any) => {
          console.error('Error exporting Zip:', error);
        })
  }

  async exportExtraData() : Promise<void> {
    await this.fileService
      .exportToExcel(
        `/dealer_portal/target-ach/additional-rebate-completion/export?year=${this.selectedYear}`
      ).subscribe(async (response: HttpResponse<Blob>) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        let fileName = 'export.xlsx';
        if (contentDisposition) {
          const matches = /filename\*?=(?:UTF-8'')?"?([^"]+)"?/.exec(contentDisposition);
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]);
          }
        }
        saveAs(response.body!, fileName);
      },
        (error: any) => {
          console.error('Error exporting Zip:', error);
        })
  }

  async exportMarketData() : Promise<void> {
    await this.fileService
      .exportToExcel(
        `/dealer_portal/target-ach/market-rebate-completion/export?year=${this.selectedYear}`
      ).subscribe(async (response: HttpResponse<Blob>) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        let fileName = 'export.xlsx';
        if (contentDisposition) {
          const matches = /filename\*?=(?:UTF-8'')?"?([^"]+)"?/.exec(contentDisposition);
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]);
          }
        }
        saveAs(response.body!, fileName);
      },
        (error: any) => {
          console.error('Error exporting Zip:', error);
        })
  }

}
